import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loader2, Save } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

export const useIntegrations = () =>
  useQuery({ queryKey: ["integrations"], queryFn: () => api.get("/admin/integrations").then((r) => r.data) });

export const useIntegrationForm = (keys) => {
  const { data } = useIntegrations();
  const qc = useQueryClient();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const toForm = (d) => Object.fromEntries(keys.map((k) => [k, d[k] || ""]));
  useEffect(() => {
    if (data) setForm(toForm(data));
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async (extra = {}, clear = []) => {
    setBusy(true);
    try {
      const { data: saved } = await api.put("/admin/integrations", { values: { ...form, ...extra }, clear });
      qc.setQueryData(["integrations"], saved);
      setForm(toForm(saved));
      qc.invalidateQueries({ queryKey: ["catalog"] });
      toast.success("Saved");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  return { data, form, set: (p) => setForm((f) => ({ ...f, ...p })), save, busy };
};

export const SaveButton = ({ busy, onClick, testid }) => (
  <button type="button" className="btn-primary" disabled={busy} onClick={onClick} data-testid={testid}>
    {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}Save
  </button>
);

export const KeyField = ({ label, name, form, set, secret, hint, testid }) => (
  <label className="field">
    <span className="field-label">{label}</span>
    <input className="field-input font-mono" type={secret ? "password" : "text"} autoComplete="off" value={form[name]}
      placeholder={hint} onFocus={() => secret && form[name].startsWith("\u2022") && set({ [name]: "" })}
      onChange={(e) => set({ [name]: e.target.value })} data-testid={testid} />
  </label>
);
